var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4939_73352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5128 2.57959H1.77607C1.14386 2.57959 0.631348 3.0921 0.631348 3.72431V16.3163C0.631348 16.9485 1.14386 17.461 1.77607 17.461H15.5128C16.145 17.461 16.6575 16.9485 16.6575 16.3163V3.72431C16.6575 3.0921 16.145 2.57959 15.5128 2.57959Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91745 11.5859L1.88635 7.81508H2.35035L3.1384 10.8863H3.17522L3.978 7.81508H4.49355L5.29633 10.8863H5.33315L6.1212 7.81508H6.5852L5.5541 11.5859H5.08275L4.25051 8.58103H4.22105L3.38881 11.5859H2.91745ZM7.15414 11.5859V7.81508H9.42991V8.22015H7.61077V9.49429H9.31207V9.89936H7.61077V11.1809H9.45937V11.5859H7.15414ZM10.2529 11.5859V7.81508H11.5713C11.834 7.81508 12.0506 7.8605 12.2212 7.95133C12.3919 8.04094 12.5189 8.16185 12.6024 8.31405C12.6858 8.46504 12.7276 8.63259 12.7276 8.81671C12.7276 8.97874 12.6987 9.11254 12.641 9.2181C12.5846 9.32367 12.5097 9.40714 12.4164 9.46851C12.3243 9.52989 12.2243 9.5753 12.1163 9.60476V9.64159C12.2317 9.64895 12.3477 9.68946 12.4643 9.76311C12.5809 9.83676 12.6785 9.94232 12.757 10.0798C12.8356 10.2173 12.8749 10.3854 12.8749 10.5843C12.8749 10.7733 12.8319 10.9433 12.746 11.0943C12.6601 11.2453 12.5244 11.365 12.3391 11.4534C12.1537 11.5417 11.9125 11.5859 11.6155 11.5859H10.2529ZM10.7096 11.1809H11.6155C11.9137 11.1809 12.1255 11.1232 12.2507 11.0078C12.3771 10.8912 12.4403 10.75 12.4403 10.5843C12.4403 10.4566 12.4078 10.3388 12.3428 10.2308C12.2777 10.1215 12.185 10.0344 12.0647 9.96933C11.9444 9.90304 11.802 9.8699 11.6376 9.8699H10.7096V11.1809ZM10.7096 9.47219H11.5565C11.694 9.47219 11.818 9.44519 11.9285 9.39118C12.0402 9.33717 12.1286 9.26107 12.1936 9.16287C12.2599 9.06467 12.293 8.94928 12.293 8.81671C12.293 8.651 12.2353 8.51045 12.12 8.39507C12.0046 8.27846 11.8217 8.22015 11.5713 8.22015H10.7096V9.47219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6575 2.57959H0.631348V4.86904H16.6575V2.57959Z",
    fill: "#6E7378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5128 1.43481H1.77607C1.14386 1.43481 0.631348 1.94733 0.631348 2.57954V3.72426C0.631348 4.35648 1.14386 4.86899 1.77607 4.86899H15.5128C16.145 4.86899 16.6575 4.35648 16.6575 3.72426V2.57954C16.6575 1.94733 16.145 1.43481 15.5128 1.43481Z",
    fill: "#6E7378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49326 3.72431C3.80937 3.72431 4.06562 3.46806 4.06562 3.15195C4.06562 2.83585 3.80937 2.57959 3.49326 2.57959C3.17715 2.57959 2.9209 2.83585 2.9209 3.15195C2.9209 3.46806 3.17715 3.72431 3.49326 3.72431Z",
    fill: "#FF3296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78232 3.72431C6.09843 3.72431 6.35469 3.46806 6.35469 3.15195C6.35469 2.83585 6.09843 2.57959 5.78232 2.57959C5.46622 2.57959 5.20996 2.83585 5.20996 3.15195C5.20996 3.46806 5.46622 3.72431 5.78232 3.72431Z",
    fill: "#FFC814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07187 3.72431C8.38798 3.72431 8.64424 3.46806 8.64424 3.15195C8.64424 2.83585 8.38798 2.57959 8.07187 2.57959C7.75577 2.57959 7.49951 2.83585 7.49951 3.15195C7.49951 3.46806 7.75577 3.72431 8.07187 3.72431Z",
    fill: "#14C864"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4939_73352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1387 14.6569H2.9209V12.3126H14.1372L14.158 11.7369L14.1644 10.0198L18.9471 13.4447L14.1387 16.8881L14.1452 15.171L14.1387 14.6569Z",
    fill: "#555555"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4939_73352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3156,
    height: 18.3156,
    fill: "white",
    transform: "translate(0.631348 0.289551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4939_73352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3025,
    height: 6.86835,
    fill: "white",
    transform: "translate(8.64453 10.0198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.085cc53b03f17da8b22c34abb1b3c827.svg";
export { ForwardRef as ReactComponent };